<template>
  <div class="notice">
    <a
      v-for="(notice, index) in noticeList"
      href="javascript:void(0)"
      @click.prevent="noticePopupOpen(index)"
      :key="`notice_${index}`"
    >
      <span class="badge artwork ui">공지사항</span>
      <span>{{ notice.title }}</span>
    </a>
  </div>
</template>
<script>
export default {
  name: 'NoticeList',
  props: {
    noticeList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    noticePopupOpen (noticeIndex) {
      const { query = {} } = this.$route
      const { contentid: contentId = '', programid: programId = '' } = query
      const id = contentId ? `contentid=${contentId}` : `programid=${programId}`

      this.$router.push(`/player/vod?${id}&isNotice=y&noticeIdx=${noticeIndex}`)
    }
  }
}
</script>
